var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseSquare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.68 0.5C35.46 0.5 40 5.26 40 12.34V28.682C40 35.742 35.46 40.5 28.68 40.5H11.34C4.56 40.5 0 35.742 0 28.682V12.34C0 5.26 4.56 0.5 11.34 0.5H28.68ZM26.02 14.442C25.34 13.76 24.24 13.76 23.54 14.442L20 18L16.44 14.442C15.74 13.76 14.64 13.76 13.96 14.442C13.28 15.122 13.28 16.242 13.96 16.92L17.52 20.482L13.96 24.022C13.28 24.722 13.28 25.822 13.96 26.5C14.3 26.84 14.76 27.022 15.2 27.022C15.66 27.022 16.1 26.84 16.44 26.5L20 22.962L23.56 26.5C23.9 26.862 24.34 27.022 24.78 27.022C25.24 27.022 25.68 26.84 26.02 26.5C26.7 25.822 26.7 24.722 26.02 24.042L22.46 20.482L26.02 16.92C26.7 16.242 26.7 15.122 26.02 14.442Z",
    fill: "#ED1C24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSquare);
export default __webpack_public_path__ + "static/media/close-square.3428b83e4729b05f0bb976b0cedca48f.svg";
export { ForwardRef as ReactComponent };